import React from 'react';

const buttonStyle = {
    width: 'auto',
    height: 'auto',
    backgroundColor: 'transparent',
    color: 'white',
    border: '1px solid white',
    borderRadius: '10px',
    marginLeft: '10px',
    marginRight: '10px',
    fontSize: '1em',
    padding: '5px 10px 5px 10px',
    fontFamily: `'Helvetica Neue', futura-pt, sans-serif`,
};

function Button({ onClick, label, isInactive, width }) {
    const border = isInactive ? 'none' : '1px solid white';
    return (
        <button
            style={{ ...buttonStyle, border: border, width: width }}
            type="button"
            onClick={onClick}
        >
            {label}
        </button>
    );
}

export default Button;
